import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, Link } from 'react-router-dom'; 
import { useNavigate } from 'react-router-dom';

// Dodajemy import Link

const Type = () => {
  const { categoryId } = useParams();
  const navigate = useNavigate();

  // Definiowanie stanu dla types i setTypes
  const [types, setTypes] = useState([]);

  useEffect(() => {
    async function fetchTypes() {
      try {
        const response = await axios.get(`http://161.97.115.122:5000/typy/${categoryId}`);
        setTypes(response.data);
      } catch (error) {
        console.error("Błąd podczas pobierania typów:", error);
      }
    }

    fetchTypes();
  }, [categoryId]);

  return (
<div className="app-container">
    <div className="sidebar">
     <img className="logo" src="https://agrofrankopol-sklep.pl/wp-content/uploads/2022/05/logo-1024x635.png" alt="Logo" />

  <div className="menu">
 
    <ul>
     <li><a href="http://161.97.115.122:3000/">Strona Główna</a></li>
        <li><a href="https://agrofrankopol-sklep.pl/">Sklep internetowy</a></li>
        <li><a href="https://agrofrankopol-sklep.pl/kontakt/">Kontakt</a></li>
    </ul>
</div>
    </div>
    <div className="content">
                <button onClick={() => navigate(-1)} className="back-button">Wstecz</button>


    <div className="katalog">
      <h1>Typy</h1>
       <ul>
      {types.map(type => (
        <li key={type._id} className="type-item">
          <div className="type-image">

          </div>
          <div className="type-info">
            <Link to={`/model/${type._id}`} className="type-link">
              {type.nazwa}
            </Link>
          </div>
        </li>
      ))}
    </ul>
    </div>
    </div>
    </div>
  );
}

export default Type;
